<template>
  <div class="user-manage-constructor main-body">
    <div class="button-search-body">
      <div class="search-body">
        <div class="button-body">
          <ButtonList 
            :list="buttonList"
            :target="buttonTarget"
          />
        </div>
      </div>
    </div>
    <div class="table-body">
      <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
      ></TableCom>
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.limit"
      />
    </div>
      <AddUser
        v-if="addUserFlag"
        :target="addUserTarget"
        :title="title"
        @close="userFlagClose"
        @refresh="selectList" />
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import TableCom from '@/components/TableCom'
import Pagination from '@/components/Pagination'
import ButtonList from '@/components/ButtonList'
import {
  ElLoading, ElMessageBox, ElImageViewer,
} from 'element-plus'
import { selectUserList, enableUser, delUser } from '@/api/System/UserManager'
import AddUser from '@/views/UserManager/component/adduser.vue'
// props
const props = defineProps({
  
})
// emit
const emit = defineEmits([
  
])

const addUserFlag = ref(false)
const addUserTarget = ref(undefined)
const title = ref('')
const addFun = (target, button, loadFn) => {
  addUserFlag.value = true
  title.value = '添加用户'
  addUserTarget.value = { ...target }
  selectList()
  loadFn()
}
const userFlagClose = () => {
  addUserTarget.value = ''
  addUserFlag.value = false
}

const searchFun = (target, button, loadFn) => {
  selectList()
  loadFn()
}

const editUser = (target, button, loadFn) => {
  addUserFlag.value = true
  title.value = '编辑用户'
  addUserTarget.value = Object.assign({},{
    ...target,
    tel: target['userTel'],
  })
  loadFn()
}

const enable = async(target, button, loadFn) => {
  const confirmation = await ElMessageBox.confirm(
      '是否启用该用户？',
      '确认启用',
      {
        confirmButtonText: '启用并关闭',
        cancelButtonText: '不启用',
        type: 'warning'
      }
    ).catch((err) => {
      console.log(err)
    })
    if (confirmation) {
      enableUser(target).then(res=>{
      if(res.data.code == 1004){
        message('启用成功', 1)
        selectList()
      }
    })
  }
  loadFn()
  return 
}

const disable = async(target, button, loadFn) => {
  const confirmation = await ElMessageBox.confirm(
      '是否禁用该用户？',
      '确认禁用',
      {
        confirmButtonText: '禁用并关闭',
        cancelButtonText: '不禁用',
        type: 'warning'
      }
    ).catch((err) => {
      console.log(err)
    })
    if (confirmation) {
      delUser(target).then(res=>{
      if(res.data.code == 1004){
        message('禁用成功', 1)
        selectList()
      }
    })
  }
  loadFn()
  return 
}

// 需要序号可添加
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.limit + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },
  { label: '用户名', prop: 'userName', },
  { label: '创建者', prop: 'createAuthor', },
  { label: '创建时间', prop: 'createTime', },
  { label: '有效时间', prop: 'effectiveTime', },
  { label: '角色名称', prop: 'roleName', },
  { label: '类型名称', prop: 'typeName', },
  { label: '用户状态', prop: 'userStatus', },
  { label: '操作', 
    buttonList: [
      { name: '修改', icon: 'el-Edit', fun: editUser, type: 'warning' },
      { name: '启用', icon: 'enable', fun: enable, type: 'primary' },
      { name: '禁用', icon: 'disabled', fun: disable, type: 'danger' },
    ]
  }
])

const buttonTarget = ref({});
const buttonList = ref([
  // { name: '查询', icon: 'el-Search', type: 'primary', fun: searchFun },
  { name: '添加用户', icon: 'el-Plus', type: 'primary', fun: addFun },
])

const tableList = ref([])
let total = ref(0),
    listQuery = reactive({
      page: 1,
      limit: 20
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  // console.log(listQuery);
  let load = ElLoading.service({
    lock: true,
    target: '.main-body',
    background: 'var(--loadBackColor)'
  })
  selectUserList(listQuery).then(res=>{
    if(res.data.code == 1004){
      tableList.value = res.data.data.map(user => {
        return {
          ...user,
          userStatus: user.userStatus === 1 ? '禁用' : '启用'
        }
      })
      total.value = res.data.count
    }
    load.close()
  }).catch(err=>{
    load.close()
    console.log(err)
  })
}
// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
  selectList()
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{

})

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.user-manage-constructor {
  padding: 10px;
  --h3Height: 30px;
  
}
</style>